import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import ProjectCard from './ProjectCard';
import SlotCard from './SlotCard';

const STEP_CONFIG = {
  ao:        { title: 'Avant-Vente',  accent: '#991b1b' },
  setup:     { title: 'Setup',        accent: '#d97706' },
  terrain:   { title: 'Terrain',      accent: '#059669' },
  reporting: { title: 'Reporting',    accent: '#0284c7' },
  closing:   { title: 'Closing',      accent: '#7c3aed' },
};

const KanbanColumn = ({ step, projects, slotGroups, onCardClick, onSlotClick, hideHeader }) => {
  const { setNodeRef, isOver } = useDroppable({ id: step });
  const cfg = STEP_CONFIG[step] || { title: step, accent: '#757575' };

  const safeGroups = Array.isArray(slotGroups) ? slotGroups : [];
  const safeProjects = Array.isArray(projects) ? projects : [];

  const totalItems = safeProjects.length + safeGroups.reduce((s, g) => s + (g?.slots?.length || 0), 0);

  const sortableIds = [
    ...safeProjects.map(p => `project-${p.id}`),
    ...safeGroups.flatMap(g => (g?.slots || []).map(s => `slot-${s.id}`)),
  ];

  const body = (
      <div ref={setNodeRef} className={`kanban-col-body${isOver ? ' is-over' : ''}`}>
        {totalItems === 0 && !isOver && (
          <div className="kanban-col-empty">
            <span style={{ fontSize: '1.2rem', opacity: 0.3 }}>○</span>
            Aucun élément
          </div>
        )}
        {(totalItems > 0 || isOver) && (
          <SortableContext items={sortableIds} strategy={verticalListSortingStrategy}>
            {/* Project cards */}
            {safeProjects.map(project => (
              <ProjectCard
                key={project.id}
                project={project}
                onClick={onCardClick}
                accentColor={cfg.accent}
              />
            ))}

            {/* Slot groups */}
            {safeGroups.map(group => (
              <div key={group.project.id} style={{ marginBottom: 12 }}>
                {/* Project group header */}
                <div
                  onClick={() => onCardClick(group.project.id)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: 8,
                    padding: '7px 10px', marginBottom: 4,
                    cursor: 'pointer', borderRadius: 6,
                    transition: 'background 0.12s',
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = '#eee'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <div style={{ width: 3, height: 16, borderRadius: 2, background: cfg.accent, opacity: 0.6, flexShrink: 0 }} />
                  <span style={{
                    fontSize: '0.72rem', fontWeight: 600, color: '#424242',
                    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1,
                  }}>
                    {group.project.name}
                  </span>
                  <span style={{
                    fontSize: '0.6rem', fontWeight: 600, color: '#9e9e9e',
                    background: '#e8e8e8', padding: '1px 7px', borderRadius: 10,
                  }}>
                    {group.slots.length}
                  </span>
                </div>
                {/* Slot cards */}
                {group.slots.map(slot => (
                  <SlotCard
                    key={slot.id}
                    slot={slot}
                    project={group.project}
                    accentColor={cfg.accent}
                    onClick={() => onSlotClick && onSlotClick(slot, group.project)}
                  />
                ))}
              </div>
            ))}
          </SortableContext>
        )}
      </div>
  );

  if (hideHeader) return body;

  return (
    <div className={`kanban-col${isOver ? ' kanban-col-drop-target' : ''}`} style={{ '--col-accent': cfg.accent }}>
      {body}
    </div>
  );
};

export default KanbanColumn;
